// Every email link of a Firebase project opens the project's one action URL, and on the dev project that
// is this reset-password page. A SIGN-IN link (mode=signIn) meant for another of our sites therefore landed
// on a reset form it has nothing to do with (Super Admin staff invites, 30 Sep). Such a link carries the
// site it was requested from in continueUrl, so it is sent on there with its code untouched.
//
// Only our own hosts: forwarding a one-time code to an address taken from the query string would
// otherwise be an open redirect.
const ALLOWED_HOSTS = [/\.exsportia\.com$/, /\.mysportia\.com$/, /^exsportia-super-admin(-dev)?\.web\.app$/]

export const signInLinkTarget = (search: string): string | null => {
  const params = new URLSearchParams(search)
  const continueUrl = params.get('continueUrl')
  if (params.get('mode') !== 'signIn' || !continueUrl) {
 return null
}
  try {
    const target = new URL(continueUrl)
    if (target.protocol !== 'https:' || !ALLOWED_HOSTS.some(host => host.test(target.hostname))) {
 return null
}
    return `${target.origin}/${search.startsWith('?') ? search : `?${search}`}`
  } catch {
    return null
  }
}
